import { Identification } from './identification'

export type AditionalInfo = Nullable<{
  onBusinessBehalf: boolean
  financedInsurable: boolean
  financialEntityName: string
}> & {
  business: Identification
}

function load(model?: Partial<AditionalInfo> | null): AditionalInfo {
  return {
    onBusinessBehalf: model?.onBusinessBehalf ?? false,
    business: model?.business ?? Identification.load(),
    financedInsurable: model?.financedInsurable ?? false,
    financialEntityName: model?.financialEntityName ?? null,
  }
}

export const AditionalInfo = {
  load,
}
